var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"icon-text-link",class:_vm.addClass,on:{"click":_vm.clickOperation}},[_c('v-icon',{attrs:{"color":_vm.color,"disabled":_vm.isDisabled}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }